import platform from "platform";
export function getBrowserInfo() {
    var _platform_name, _platform_os, _platform_os1, _platform_os2;
    return {
        browser: (_platform_name = platform.name) === null || _platform_name === void 0 ? void 0 : _platform_name.toLocaleLowerCase(),
        browserVersion: platform.version,
        operatingSystem: "".concat((_platform_os = platform.os) === null || _platform_os === void 0 ? void 0 : _platform_os.family, " v").concat((_platform_os1 = platform.os) === null || _platform_os1 === void 0 ? void 0 : _platform_os1.version, " (x").concat((_platform_os2 = platform.os) === null || _platform_os2 === void 0 ? void 0 : _platform_os2.architecture, ")"),
        viewportWidth: window.innerWidth,
        viewportHeight: window.innerHeight,
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
        screenOrientation: window.screen.orientation ? window.screen.orientation.type : "any"
    };
}
